import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=5f450d42&"
import script from "./StatusList.vue?vue&type=script&lang=js&"
export * from "./StatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports